import styles from './styles/FeaturesPanel.css'
import { Link, useHistory } from 'react-router-dom'
import Header from '../typography/Header'
import P from 'components/typography/Paragraph'
import Button from '../forms/Button'
import Feature from '../navbar/Feature'
import Card from '../layout/Card'
import * as analytics from 'lib/analytics'

const FeaturesPanel = () => {
  const history = useHistory()
  const handleExampleClick = (text) => {
    history.push(`/assistant?startTerm=${encodeURIComponent(text)}`)
    analytics.event({
      category: 'Assistant',
      action: 'Click on example query (homepage)',
      label: text
    })
  }
  return (
    <div className={styles.container}>
      <div className={styles.layout}>
        <Header className={styles.header} level={3}>
          Never waste time looking for and evaluating research again
        </Header>
        <P className={styles.paragraph}>
          Our innovative index of Smart Citations powers new features built to make research intuitive and trustworthy for anyone engaging with research.
        </P>
        <div className={styles.featureGrid}>
          <Card level={4} className={styles.featureCard}>
            <Feature
              imgTop
              className={styles.feature}
              to='/search'
              header='Search Citation Statements'
              img={`${CONFIG.assetsBaseURL}/images/icons/feature-search.svg`}
            >
              Find information by searching across a mix of metadata (like titles & abstracts) as well as Citation Statements we indexed from the full-text of research articles.
            </Feature>
          </Card>
          <Card level={4} className={styles.featureCard}>
            <Feature
              imgTop
              className={styles.feature}
              to='/create-dashboard'
              header='Create Custom Dashboards'
              img={`${CONFIG.assetsBaseURL}/images/icons/feature-dashboards.svg`}
            >
              Build and manage collections of articles of interest -- from a manual list, systematic review, or a search -- and get aggregate insights, notifications, and more.
            </Feature>
          </Card>
          <Card level={4} className={styles.featureCard}>
            <Feature
              imgTop
              className={styles.feature}
              to='/?referenceCheck'
              header='Reference Check'
              img={`${CONFIG.assetsBaseURL}/images/icons/reference-check-feature-icon.svg`}
            >
              Evaluate how references from your manuscript were used by you or your co-authors to ensure you properly cite high quality references.
            </Feature>
          </Card>
          <Card level={4} className={styles.featureCard}>
            <Feature
              imgTop
              className={styles.feature}
              to='/journals'
              header='Journal Metrics'
              img={`${CONFIG.assetsBaseURL}/images/icons/feature-journals.svg`}
            >
              Explore pre-built journal dashboards to find their publications, top authors, compare yearly scite Index rankings in subject areas, and more.
            </Feature>
          </Card>
          <Card level={4} className={styles.featuredCard}>
            <div className={styles.featured}>
              <img alt='featured image' src={`${CONFIG.assetsBaseURL}/images/icons/assistant.svg`} />
              <P className={styles.featuredText}>
                <strong>Large Language Model (LLM) Experience for Researchers</strong>
              </P>
              <P className={styles.featuredText}>
                Assistant by scite gives you the power of large language models backed by our unique database of Smart Citations to minimize the risk of hallucinations and improve the quality of information and real references.
              </P>
              <P className={styles.featuredText}>
                Use it to get ideas for search strategies, build reference lists for a new topic you're exploring, get help writing marketing and blog posts, and more.
              </P>
              <P className={styles.featuredText}>
                Assistant is built with observability in mind to help you make more informed decisions about AI generated content.
              </P>
              <P className={styles.featuredText}>
                Here are a few examples to try:
              </P>

              <ul className={styles.featuredListItems}>
                <li className={styles.featuredListItem}>
                  <P
                    className={styles.featuredExampleLinksText} onClick={
                      () => handleExampleClick('How many rats live in NYC?')
                    }
                  >
                    "How many rats live in NYC?"  <i className='fa fa-arrow-circle-right' />
                  </P>

                </li>
                <li className={styles.featuredListItem}>

                  <P
                    className={styles.featuredExampleLinksText} onClick={
                    () => handleExampleClick('How does the structure of a protein affect its function?')
                  }
                  >
                    "How does the structure of a protein affect its function?"  <i className='fa fa-arrow-circle-right' />
                  </P>
                </li>
              </ul>
              <div className={styles.btnGroup}>
                <Link to='/assistant'>
                  <Button className={styles.btn} color='blue' bold>
                    Try Assistant Now
                  </Button>
                </Link>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>
  )
}

export default FeaturesPanel
